import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'lucide-react';
import { ForgotPassword } from './ForgotPassword';
interface LoginCardProps {
  onLogin: () => void;
}
export function LoginCard({
  onLogin
}: LoginCardProps) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const isValidForm = userId.trim() !== '' && password.length >= 12;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValidForm) {
      onLogin();
    }
  };
  if (showForgotPassword) {
    return <ForgotPassword onBack={() => setShowForgotPassword(false)} data-id="element-45" />;
  }
  return <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100" data-id="element-46">
      <h2 className="text-2xl font-semibold text-[#1A1F36] mb-6" data-id="element-47">Login</h2>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-48">
        <div className="space-y-2" data-id="element-49">
          <label htmlFor="userId" className="block text-sm font-medium text-gray-700" data-id="element-50">
            User ID
          </label>
          <input id="userId" type="text" value={userId} onChange={e => setUserId(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter your user ID" required data-id="element-51" />
        </div>
        <div className="space-y-2" data-id="element-52">
          <div className="flex items-center justify-between" data-id="element-53">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-54">
              Password
            </label>
            <div className="relative group" data-id="element-55">
              <InfoIcon className="h-4 w-4 text-gray-500 cursor-help" data-id="element-56" />
              <div className="absolute right-0 bottom-full mb-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg p-3 text-xs hidden group-hover:block z-10" data-id="element-57">
                <p className="font-medium text-gray-700 mb-1" data-id="element-58">
                  Password must contain:
                </p>
                <ul className="list-disc pl-4 text-gray-600 space-y-1" data-id="element-59">
                  <li data-id="element-60">Minimum 12 characters</li>
                  <li data-id="element-61">At least 1 uppercase letter</li>
                  <li data-id="element-62">At least 1 lowercase letter</li>
                  <li data-id="element-63">At least 1 number</li>
                  <li data-id="element-64">At least 1 special character</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="relative" data-id="element-65">
            <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter your password" required data-id="element-66" />
            <button type="button" className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" onClick={() => setShowPassword(!showPassword)} data-id="element-67">
              {showPassword ? <EyeOffIcon size={18} data-id="element-68" /> : <EyeIcon size={18} data-id="element-69" />}
            </button>
          </div>
        </div>
        <div data-id="element-70">
          <button type="submit" disabled={!isValidForm} className={`w-full py-2 px-4 rounded-md font-medium text-white ${isValidForm ? 'bg-[#F58220] hover:bg-[#e07619] focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:ring-opacity-50' : 'bg-gray-300 cursor-not-allowed'}`} data-id="element-71">
            Login
          </button>
        </div>
        <div className="text-center" data-id="element-72">
          <button type="button" onClick={() => setShowForgotPassword(true)} className="text-sm text-[#F58220] hover:text-[#e07619] font-medium" data-id="element-73">
            Forgot Password?
          </button>
        </div>
      </form>
    </div>;
}